// extracted by mini-css-extract-plugin
export var bgColor = "styles-module--bgColor--73d94";
export var scrollBar = "styles-module--scrollBar--cf944";